import HttpService from './http.service';

class ProductService {
  suggestProducts(params) {
    return HttpService.get('products/suggestions', {
      params,
    })
      .then((res) => res.data);
  }

  getProductPrice(params) {
    return HttpService.get(`products/${params.product_id}/price`, {
      params,
    })
      .then((res) => res.data);
  }

  getProductTypes() {
    return HttpService.get('product_types')
      .then((res) => res.data);
  }

  getProducts(params) {
    return HttpService.get('products', {
      params,
    })
      .then((res) => res.data);
  }

  getProduct(id) {
    return HttpService.get(`products/${id}`)
      .then((res) => res.data);
  }

  createProduct(product) {
    return HttpService.post('products', product)
      .then((res) => res.data);
  }

  updateProduct(product) {
    return HttpService.patch(`products/${product.id}`, product)
      .then((res) => res.data);
  }

  deleteProduct(product) {
    return HttpService.delete(`products/${product.id}`)
      .then((res) => res.data);
  }
}

export default new ProductService();
